import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import Loader from '../../../../component/Loader/Loader';

export const ChartListView = ({ lineChartData, chartViewType }) => {
    const [chartOption, setChartOption] = useState(null);

    useEffect(() => {
        if (!lineChartData || Object.keys(lineChartData).length === 0) {
            setChartOption({
                xAxis: { type: 'category', data: [] },
                yAxis: { type: 'value' },
                series: [],
                backgroundColor: '#0D0D0D',
            });
            return;
        }

        let options;

        if (chartViewType === 'pie') {
            // Aggregate data for the pie chart
            const pieData = Object.keys(lineChartData).map(key => {
                const totalValue = lineChartData[key].reduce((sum, item) => sum + item.value, 0);
                return { name: key, value: totalValue };
            });

            options = {
                title: {
                    text: '',
                    textStyle: { color: '#fff' },
                },
                tooltip: {
                    trigger: 'item', // For pie charts, trigger on item
                    formatter: '{a} <br/>{b} : {c} ({d}%)', // Custom formatter for pie tooltip
                },
                legend: {
                    orient: 'vertical', // Vertical legend for better readability with many slices
                    left: 'left',
                    data: Object.keys(lineChartData),
                    textStyle: { color: '#fff' },
                },
                series: [
                    {
                        name: 'Channels', // Series name
                        type: 'pie',
                        radius: '70%', // Size of the pie chart
                        center: ['50%', '50%'], // Center position of the pie chart
                        data: pieData,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        label: {
                            color: '#fff' // Label color
                        },
                        labelLine: {
                            lineStyle: {
                                color: '#fff' // Label line color
                            }
                        }
                    }
                ],
                backgroundColor: '#0D0D0D',
            };
        } else {
            // Existing logic for line and bar charts
            const series = Object.keys(lineChartData).map((key) => ({
                name: key,
                type: chartViewType,
                data: lineChartData[key].map(item => [item.timestamp, item.value]),
                stack: chartViewType === 'bar' ? 'total' : null, // stacking only for bar chart
                smooth: chartViewType === 'line' ? 0.2 : false,
                lineStyle: chartViewType === 'line' ? { width: 2 } : undefined,
            }));

            options = {
                title: {
                    text: '',
                    textStyle: { color: '#fff' },
                },
                tooltip: {
                    trigger: 'axis',
                },
                graphic: [
                    {
                        type: 'text',
                        left: 20,
                        bottom: 10,
                        style: {
                            text: 'Channels:',
                            fill: '#fff',
                            font: '14px sans-serif',
                        },
                    },
                ],
                dataZoom: [
                    {
                        type: 'inside',
                        xAxisIndex: 0,
                        zoomOnMouseWheel: true,
                        moveOnMouseMove: true,
                        moveOnMouseWheel: true,
                    },
                    {
                        type: 'slider',
                        show: true,
                        xAxisIndex: 0,
                        bottom: 50,
                        height: 20,
                        fillerColor: '#8883',
                        borderColor: '#444',
                        handleStyle: {
                            color: '#aaa',
                        },
                    },
                ],
                legend: {
                    data: Object.keys(lineChartData),
                    textStyle: { color: '#fff' },
                    bottom: 7,
                    left: 100,
                    orient: 'horizontal'
                },
                grid: {
                    top: 20,
                    right: 20,
                    bottom: 70,
                    left: 20,
                    containLabel: true,
                },
                xAxis: {
                    type: 'time',
                    axisLine: { lineStyle: { color: '#888' } },
                    axisLabel: { color: '#fff' },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#444',
                            type: 'dashed',
                        },
                    },
                },
                yAxis: {
                    type: 'value',
                    axisLine: { lineStyle: { color: '#888' } },
                    axisLabel: { color: '#fff' },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#444',
                            type: 'dashed',
                        },
                    },
                },
                series,
                backgroundColor: '#0D0D0D',
            };
        }
        setChartOption(options);

    }, [lineChartData, chartViewType]);

    return (
        <div className="mt-3">
            {chartOption ? (
                <ReactECharts
                    key={chartViewType} // Important to change key when chart type changes for full re-render
                    option={chartOption}
                    notMerge={true}
                    lazyUpdate={false}
                    style={{ height: "70vh", width: '100%', borderRadius: "6px", overflow: "hidden" }}
                />
            ) : (
                <div className="tableLoader">
                    <Loader></Loader>
                </div>
            )}
        </div>
    );
};